import React, { useState } from 'react';
import axios from 'axios';

// Drop-in waitlist email form. Replaces inline e.preventDefault() <form>s
// across the marketing pages. Each call site passes a distinct `source`
// string so we can see in MongoDB which CTAs convert. Optional `plan`
// records what plan they were eyeing when they signed up.
//
// Usage:
//   <WaitlistForm source="landing-hero" inputWidth={280} className="hero-cta-row" />
//   <WaitlistForm source="features-final" />
//   <WaitlistForm source="role-hero" plan={role.slug} />

const WaitlistForm = ({
  source,
  plan = null,
  inputWidth = 300,
  inputPlaceholder = 'work@yourcompany.com',
  buttonLabel = 'Join the waitlist →',
  buttonSubmittingLabel = 'Adding you…',
  successText = "You're on the list. We'll be in touch when sign-ups open.",
  className,
  style,
}) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'submitting' | 'done'
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!/\S+@\S+\.\S+/.test(email)) { setError('Please enter a valid email address.'); return; }
    setStatus('submitting');
    try {
      await axios.post('/api/waitlist', { email, source, plan });
      setStatus('done');
    } catch (err) {
      setError(err.response?.data?.msg || "Couldn't add you right now. Try again in a moment.");
      setStatus('idle');
    }
  };

  if (status === 'done') {
    return (
      <div role="status" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '10px 16px', background: 'rgba(45,160,106,0.12)', color: 'var(--green)', border: '1px solid color-mix(in oklab, var(--green) 30%, transparent)', borderRadius: 12, fontSize: 14, fontWeight: 500, ...style }}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M3 9.5l3.5 3.5 8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {successText}
      </div>
    );
  }

  const defaultStyle = { display: 'inline-flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' };
  return (
    <>
      <form onSubmit={submit} className={className} style={className ? style : { ...defaultStyle, ...style }}>
        <input
          className="input input-lg"
          type="email"
          placeholder={inputPlaceholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: inputWidth }}
          required
          autoComplete="email"
        />
        <button className="btn btn-accent btn-lg" type="submit" disabled={status === 'submitting'}>
          {status === 'submitting' ? buttonSubmittingLabel : buttonLabel}
        </button>
      </form>
      {error && (
        <div role="alert" style={{ marginTop: 10, fontSize: 13, color: '#d2604f', fontWeight: 500 }}>{error}</div>
      )}
    </>
  );
};

export default WaitlistForm;
